import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  add_subject,
  delete_subject,
  get_subject,
  get_subject_list,
  update_subject,
} from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  subjects: [],
  subjectlist: [],
  school_id: "",
  class_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    subject_code: "",
    school_class: "",
  },
};
// Async Thunks for API Calls
export const fetchsubjectList = createAsyncThunk(
  "subject/fetchsubjectlist",
  async ({school_id,class_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_subject_list(
        school_id,
        class_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async Thunks for API Calls
export const fetchsubject = createAsyncThunk(
  "subject/fetchsubject",
  async (
    {
      page,
      page_size,
      school_id,
      filter_fields,
      class_id,
      token,
      signal,
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_subject(
        page,
        page_size,
        school_id,
        filter_fields,
        class_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createsubject = createAsyncThunk(
  "subject/createsubject",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_subject(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatesubject = createAsyncThunk(
  "subject/updatesubject",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_subject(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletesubject = createAsyncThunk(
  "subject/deletesubject",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_subject({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const subjectSlice = createSlice({
  name: "subjects",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name, teacher, school_class } =
        action.payload;
      state.formData = { id, name, teacher, school_class };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        subject_code: "",
        school_class: "",
      };
    },
    setSubject(state, action) {
      state.subjects = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },

    setClassId(state, action) {
      state.class_id = action.payload;
    },
  },


  extraReducers: (builder) => {
    builder
      // section list
      .addCase(fetchsubjectList.fulfilled, (state, action) => {
        state.subjectlist = action.payload.data;
      })
      .addCase(fetchsubjectList.rejected, (state, action) => {
        state.subjectlist = [];
      })
      // Fetch Classes
      .addCase(fetchsubject.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchsubject.fulfilled, (state, action) => {
        console.log(action.payload.results);
        state.loading = false;
        state.subjects = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchsubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createsubject.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createsubject.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createsubject.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatesubject.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatesubject.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatesubject.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete Class
      .addCase(deletesubject.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletesubject.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletesubject.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

export const {
  setSubject,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  setClassId,
} = subjectSlice.actions;
export default subjectSlice.reducer;
